import { PET_PRODUCTS } from './petProducts';

export const PRODUCT_CATALOG = {
  'sticle-pet': PET_PRODUCTS,
  preforme: [],
  'capace-manere': [
    {
      id: 'cap-dop-30-25',
      i18nKey: 'products.caps.dop3025',
      neckTypes: ['neck3025'],
      images: ['/images/capace/Dop_3025_1.jpg', '/images/capace/Dop_3025_2.jpg'],
    },
    {
      id: 'cap-dop-pco-1881',
      i18nKey: 'products.caps.dopPco1881',
      neckTypes: ['pco1881'],
      images: ['/images/capace/Dop_PCO_1881_1.jpg', '/images/capace/Dop_PCO_1881_2.jpg'],
    },
    {
      id: 'cap-dop-pco-1810',
      i18nKey: 'products.caps.dopPco1810',
      neckTypes: ['pco1810'],
      images: [
        '/images/capace/Dop_PCO_1810_1.jpg',
        '/images/capace/Dop_PCO1810_2.jpg',
      ],
    },
    {
      id: 'cap-dop-child-pco-1810',
      i18nKey: 'products.caps.dopProtectieCopiiPco1810',
      neckTypes: ['pco1810'],
      images: ['/images/capace/Dop_PCO1810_prot_copii_1.jpg', '/images/capace/Dop_PCO1810_prot_copii_2.jpg'],
    },
    {
      id: 'cap-dop-38-31',
      i18nKey: 'products.caps.dop3831',
      neckTypes: ['neck38mm'],
      images: ['/images/capace/Dop_3831_1.jpg', '/images/capace/Dop_3831_2.jpg'],
    },
    {
      id: 'cap-dop-48-41',
      i18nKey: 'products.caps.dop4841',
      neckTypes: ['neck48mm'],
      images: ['/images/capace/Dop_4841_1.jpg', '/images/capace/Dop_4841_2.jpg'],
    },
    {
      id: 'cap-dop-child-48-41',
      i18nKey: 'products.caps.dopProtectieCopii4841',
      neckTypes: ['neck48mm'],
      images: ['/images/capace/Dop_4841_prot_copii_1.jpg', '/images/capace/Dop_4841_prot_copii_2.jpg'],
    },
    {
      id: 'cap-dop-29-21',
      i18nKey: 'products.caps.dop2921',
      neckTypes: ['oil2921'],
      images: [
        '/images/capace/Dop_2921_1.jpg',
        '/images/capace/Dop_2921_2.jpg',
        '/images/capace/Dop_2921_3.jpg',
        '/images/capace/Dop_2921_4.jpg',
      ],
    },
    {
      id: 'cap-dop-push-pull',
      i18nKey: 'products.caps.dopPushPull',
      neckTypes: [],
      images: [
        '/images/capace/Dop_pushpull_1.jpg',
        '/images/capace/Dop_pushpull_2.jpg',
        '/images/capace/Dop_pushpull_3.jpg',
        '/images/capace/Dop_pushpull_4.jpg',
      ],
    },
    {
      id: 'cap-manere-pco-38-31-48-41',
      i18nKey: 'products.caps.manerePco38_31_48_41',
      neckTypes: ['pco1881', 'neck38mm', 'neck48mm'],
      images: ['/images/capace/Manere_1.jpg'],
    },
    { id: 'cap-pompita-sapun', i18nKey: 'products.caps.pompaSapun', neckTypes: ['pco1810'], images: ['/images/capace/Pompita_1.jpg'] },
    { id: 'cap-trigger', i18nKey: 'products.caps.trigger', neckTypes: ['pco1810'], images: ['/images/capace/Trigger_1.JPG'] },
  ],
  'galeti-bidoane': [
    {
      id: 'bidon-1l-natur',
      i18nKey: 'products.buckets.bidon1LNatur',
      type: 'bidon',
      volumeMl: 1000,
      shape: 'round',
      color: 'white',
      images: ['/images/alte_produse/Bidon_Natur_1000ml_1.jpg'],
    },
    {
      id: 'bidon-1l-gri',
      i18nKey: 'products.buckets.bidon1LGri',
      type: 'bidon',
      volumeMl: 1000,
      shape: 'round',
      color: 'gray',
      images: ['/images/alte_produse/Bidon_Gri_1000ml_1.jpg'],
    },
    {
      id: 'bidon-5l',
      i18nKey: 'products.buckets.bidon5L',
      type: 'bidon',
      volumeMl: 5000,
      shape: 'rectangular',
      color: 'white',
      images: ['/images/alte_produse/Bidon_Natur_5000ml_1.jpg'],
    },
    { id: 'flacon-0-75l', i18nKey: 'products.buckets.flacon075L', type: 'flacon', volumeMl: 750, shape: 'rectangular', color: 'white', images: ['/images/alte_produse/Flacon_750ml_1.jpg'] },
    {
      id: 'canistra-euro-5l',
      i18nKey: 'products.buckets.canistraEuro5_10L',
      type: 'canistra',
      volumeMl: 5000,
      volumeLabel: '5L / 10L',
      shape: 'rectangular',
      color: 'white',
      images: ['/images/alte_produse/Canistra_Euro_5000ml_1.jpg'],
    },
    { id: 'caserola-0-12l', i18nKey: 'products.buckets.caserola012L', type: 'caserola', volumeMl: 120, shape: 'round', color: 'white', images: ['/images/alte_produse/caserola_120ml_1.jpg'] },
    { id: 'caserola-0-18l', i18nKey: 'products.buckets.caserola018_037L', type: 'caserola', volumeMl: 180, volumeLabel: '180ml / 370ml', shape: 'round', color: 'white', images: ['/images/alte_produse/Caserola_180ml_1.jpg'] },
    { id: 'caserola-0-52l', i18nKey: 'products.buckets.caserola052L', type: 'caserola', volumeMl: 520, shape: 'round', color: 'transparent', images: ['/images/alte_produse/Caserola_520ml_1.jpg'] },
    {
      id: 'galeata-0-5l',
      i18nKey: 'products.buckets.galeata05L',
      type: 'galeata',
      volumeMl: 500,
      shape: 'round',
      color: 'white',
      images: ['/images/alte_produse/Galeata_580ml_1.jpg'],
    },
    {
      id: 'galeata-0-85l',
      i18nKey: 'products.buckets.galeata085_1L',
      type: 'galeata',
      volumeMl: 850,
      volumeLabel: '850ml / 1000ml',
      shape: 'round',
      color: 'white',
      images: ['/images/alte_produse/Galeata_850ml_1.jpg'],
    },
    {
      id: 'galeata-1-5l',
      i18nKey: 'products.buckets.galeata12_15L',
      type: 'galeata',
      volumeMl: 1500,
      volumeLabel: '1.2L / 1.5L',
      shape: 'round',
      color: 'white',
      images: ['/images/alte_produse/Galeata_1200ml_1.jpg'],
    },
    {
      id: 'galeata-3l',
      i18nKey: 'products.buckets.galeata3_5_10_12L',
      type: 'galeata',
      volumeMl: 3000,
      volumeLabel: '3L / 5L / 10L / 12L',
      shape: 'round',
      color: 'white',
      images: ['/images/alte_produse/Galeata_3000ml_1.jpg'],
    },
    {
      id: 'galeata-oval-3l',
      i18nKey: 'products.buckets.galeataOval3L',
      type: 'galeata',
      volumeMl: 3000,
      shape: 'oval',
      color: 'white',
      images: ['/images/alte_produse/Galeata_Oval_3000ml_1.jpg'],
    },
  ],
  capace: [],
  manere: [],
  triggere: [],
  galeti: [],
  'bidoane-hdpe': [],
};

export function getProductsForCategory(category) {
  return PRODUCT_CATALOG[category] || [];
}
